export const getParentSectionId = (state) =>
  state.voting_form.parent_section.getIn(["section", "id"]);
